<template lang="pug">
v-select(
  v-model="valueModel"
  :items="isAdmin ? seasonOptions : assignedSeasons"
  :item-text="item => `${item.season} ${item.sport} - ${item.year} ${item.season_type}`.replace('_', ' ')"
  item-value="id"
  solo
  hide-details
  dense
  style="width:430px"
  label="Select Season"
  aria-label="Select Season"
)
</template>

<script>
import { mapState, mapGetters } from "vuex"

export default({
  computed: {
    ...mapState({
      coach: state => state.main.coach,
      seasonId: state => state.main.seasonId,
      isAdmin: state => state.auth.isAdmin,
      seasonOptions: state => state.main.seasonOptions
    }),
    ...mapGetters([
      'reservedFacilityIds',
      'assignedSeasons'
    ]),
    valueModel: {
      get() {
        try {
          return this.seasonId.toString()
        } catch (err) {
          return null
        }
      },
      async set(value) {
        this.$store.dispatch('selectSeason', value)
      }
    }
  }
})
</script>